import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { numberWithCommas } from '../../util/number_with_commas';
import { Container, Notification } from './notification_wrapper.styles';
const NotificationWrapper = ({ children, count }) => {
    const notification = count ? numberWithCommas(count) : undefined;
    return (_jsxs(Container, { children: [count && (_jsx(Notification, { alignItems: "center", justifyContent: "center", p: 2, borderRadius: 1, children: notification })), children] }));
};
export default NotificationWrapper;
//# sourceMappingURL=notification_wrapper.js.map